// src/AudioSpectrum/effects/galaxy.js

export const drawGalaxy = (ctx, frequencyData, width, height) => {
  const centerX = width / 2;
  const centerY = height / 2;
  
  ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
  ctx.fillRect(0, 0, width, height);
  
  const barCount = Math.min(frequencyData.length / 2, 100);
  const time = Date.now() * 0.001;
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const angle = (i / barCount) * Math.PI * 2 + time * 0.5;
    const radius = (i / barCount) * Math.min(width, height) / 2;
    const intensity = value / 255;
    
    // 별 위치 계산
    const spiralAngle = angle + radius * 0.01;
    const x = centerX + Math.cos(spiralAngle) * radius;
    const y = centerY + Math.sin(spiralAngle) * radius;
    
    // 별 그리기
    if (intensity > 0.1) {
      const starSize = intensity * 3;
      const brightness = intensity;
      
      ctx.fillStyle = `rgba(255, 255, 255, ${brightness})`;
      ctx.beginPath();
      ctx.arc(x, y, starSize, 0, Math.PI * 2);
      ctx.fill();
      
      // 반짝임 효과
      if (intensity > 0.7) {
        ctx.strokeStyle = `rgba(255, 255, 255, ${brightness * 0.5})`;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(x - starSize * 2, y);
        ctx.lineTo(x + starSize * 2, y);
        ctx.moveTo(x, y - starSize * 2);
        ctx.lineTo(x, y + starSize * 2);
        ctx.stroke();
      }
    }
  }
};